module.exports = __webpack_public_path__ + "img/vegetable-mushrooms-190x100.aa44b468.jpg";